/**
 *
 * 在程序开始前先初始化一些属性和方法
 */
require('./prototypeUtils/arrayUtil');
require('./prototypeUtils/numUtlis').NumberOperation;
require('./prototypeUtils/DateUtlis');

